export class SidebarPermissions {
  canClickDailyLog: boolean;
  canClickVoyageLog: boolean;
  canClickAddToDailyLog: boolean;
  canClickWeather: boolean;
  canClickJacking: boolean;
  canClickSafety: boolean;
  canClickConsumables: boolean;
  canClickVesselCrew: boolean;
  canClickProjectDetails: boolean;
  canClickDailyObservations: boolean;
  canClickDailyLegLoads: boolean;
  canClickMorningMinutes: boolean;
  canClickAttachments: boolean;
}

export class WeatherPermissions {
  canManageWeather: boolean;
  canViewWeather: boolean;
}

export class ProjectDetailsPermissions {
  canManageProjects: boolean;
  canViewProjects: boolean;
}

export class VesselCrewPermissions {
  canManageVesselCrew: boolean;
}

export class SafetyPermissions {
  canManageSafety: boolean;
}

export class JackingPermissions {
  canManageJackingRecords: boolean;
  canViewJackingRecords: boolean;
  canAddAmendFieldPositioning: boolean;
}

export class DailyObservationPermissions {
  canManageDailyObservations: boolean;
  canViewDailyObservations: boolean;
  canManageDailyObservationsEngineering: boolean;
  canManageDailyObservationsDeckDepartment: boolean;
}

export class LegLoadPermissions {
  canManageLegLoad: boolean;
  canViewLegLoad: boolean;
}

export class ConsumablePermissions {
  canManageConsumables: boolean;
  canViewConsumables: boolean;
}

export class DailyLogPermissions {
  canSignOffDay: boolean;
  canCompleteDay: boolean;
  canAmendPreviousDay: boolean;
  canManageDailyLog: boolean;
  canViewDailyLog: boolean;
  canMakeContractualAdjustments: boolean;
  canViewDailyProgressReports: boolean;
  canDeleteLocationChange: boolean;
}

export class DailyLegLoadPermissions {
  canManageLegLoad: boolean;
  canViewLegLoad: boolean;
}

export class VoyageLogPermissions {
  canManageVoyageLog: boolean;
  canViewVoyageLog: boolean;
}

export class MorningMinutesPermissions {
  canManageMorningMinutes: boolean;
  canViewMorningMinutes: boolean;
}

export class LockedDayPermissions {
  // raw permissions data based on user role
  canAccessLockedDay: boolean;
  canEditLockedDayOperationTimesOnly: boolean;
  canEditLockedDaySingleDayOnly: boolean;
  canEditLockedDayPreviousToCurrent: boolean;
  canEditLockedDayAll: boolean;

  // if an office staff is the one to create the snapshot - then only other office staff can access the implementer mode
  canAccessOfficeImplementer: boolean;

  // these are set locally, using the booleans above combined with other contextual data, e.g dailyLogDate, most recent date, etc
  functionalPermissions: LockedDayFunctionalPermissions;

  constructor() {
    this.functionalPermissions = new LockedDayFunctionalPermissions();
  }
}

export class LockedDayFunctionalPermissions {
  canAddRemoveOperations: boolean;
  canEditOperationTimes: boolean;
  canImpactCurrentLockedDay: boolean;
  canImpactFutureDay: boolean;
  canMarkDayComplete: boolean;
  canEditWeatherLog: boolean;
  canEditLegLoadLog: boolean;
  canAccessOfficeImplementer: boolean;
}



// WEBPACK FOOTER //
// ./src/models/permissions/permission.models.ts